import {
  type EmployerSizeBand,
  employerSizeOptions,
  isEmployerSizeBand,
} from '@/modules/jobs/signal/types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/modules/ui/components/select/Select';

interface JobEmployerSizeFieldProps {
  value: EmployerSizeBand;
  /** The value is the company's own band, shown because nobody has picked one yet. */
  suggested?: boolean;
  onChange: (employerSize: EmployerSizeBand) => void;
  /** The form's help text style. */
  helpClassName: string;
}

/**
 * The size of company the job's search prefers candidates to work at now. It ranks, never filters: people at other
 * companies, or at companies of unknown size, still turn up, lower down. A new job starts at its company's own band
 * when the company's size is known.
 */
export function JobEmployerSizeField({
  value,
  suggested = false,
  onChange,
  helpClassName,
}: JobEmployerSizeFieldProps) {
  return (
    <>
      <Select
        value={value}
        onValueChange={(v) => {
          if (isEmployerSizeBand(v)) onChange(v);
        }}
      >
        <SelectTrigger className="w-full" aria-label="Candidates' company size">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {employerSizeOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className={helpClassName}>
        {suggested && 'Suggested from the company’s size. '}
        Finlay ranks people whose current company is this size higher, without
        leaving others out.
      </p>
    </>
  );
}
